export default {
    loginVue: {
        loginTitle: 'Login',
        emailPlaceholder: 'E-mail',
        passwordPlaceholder: 'Password',
        loginButton: 'Log in'
    },
    addEditModalVue: {
        modalAddTitle: 'Add Contractor',
        modalEditTitle: 'Edit Contractor',
        firstNameLabel: 'First Name',
        lastNameLabel: 'Last Name',
        companyNameLabel: 'Company Name',
        emailLabel: 'E-mail',
        phoneLabel: 'Phone',
        streetLabel: 'Street',
        postalCodeLabel: 'Postal Code',
        cityLabel: 'City',
        countryLabel: 'Country',
        businessIDLabel: 'Bussines ID (IČO)',
        taxIDLabel: 'Tax ID (DIČ)',
        VATRegistrationNumberLabel: 'VAT Registration Number (IČ-DPH)',
        registerTypeLabel: 'Register Type',
        registerTypeTrade: 'Trade Register (ZRSR)',
        registerTypeBusiness: 'Business Register (ORSR)',
        registerDistrictLabel: 'Register District',
        selectDefault: 'Choose an option',
        registerNoLabel: 'Register Number',
        ibanLabel: 'IBAN',
        bicLabel: 'BIC',
        invoiceNumberLabel: 'Invoice Number',
        multisportLabel: 'MultiSport Card (Check if YES)',
        taxPayerLabel: 'Tax Payer (Check if YES)',
        taxRateLabel: 'Tax Rate',
        rateLabel: 'Rate',
        activeIncomeLabel: 'Active',
        pasiveIncomeLabel: 'Pasive',
        fitstNameErrorTitle: 'No first name?!',
        firstNameErrorText: 'Does your contractor really have no name?',
        lastNameErrorTitle: 'No last name?!',
        lastNameErrorText: 'Does your contractor really have no last name?',
        companyNameErrorTitle: 'No company name?!',
        companyNameErrorText: 'Does your contractor really have no company name?',
        emailErrorTitle: 'No email?!',
        emailErrorText: 'Oh, come on! Everyone has mail...',
        phoneErrorTitle: 'No phone?!',
        phoneErrorText: 'No phone, no call...',
        streetErrorTitle: 'Really?! No street?',
        streetErrorText: 'No street no pigeon mail...',
        postalCodeErrorTitle: 'Eh... No postal code?!',
        postalCodeErrorText: 'Poor pigeons... How they would find your target?',
        cityErrorTitle: 'No city?!',
        cityErrorText: 'Does your contractor live in the jungle?',
        countryErrorTitle: 'No country?!',
        countryErrorText: 'Even the jungle is in some country...',
        taxIDErrorTitle: 'Eh no tax ID?',
        taxIDErrorText: 'No tax ID, no money...',
        registerTypeErrorTitle: 'No register type!',
        registerTypeErrorText: 'Please enter register type',
        registerDistrictErrorTitle: 'No register district!',
        registerDistrictErrorText: 'Please enter register district',
        registerNoErrorTitle: 'No register number!',
        registerNoErrorText: 'Please enter register number',
        ibanErrorTitle: 'No IBAN!',
        ibanErrorText: 'No IBAN, no money!',
        bicErrorTitle: 'No BIC!',
        bicErrorText: 'No BIC, no money!',
        invoiceNumberErrorTitle: 'No invoice number!',
        invoiceNumberErrorText: 'Add your custom invoice number',
        errorButton: 'I understand!'
    },
    indexVue: {
        monthDefault: 'Choose a month',
        selectAll: 'Select All',
        timeColumn: 'Time',
        ratesColumn: 'Rates',
        activeColumn: 'Active',
        pasiveColumn: 'Pasive',
        discountColumn: 'Discount',
        extraColumn: 'Extra',
        totalColumn: 'Total',
        generatePDFButton: 'Generate Invoices',
        generateXMLButton: 'Generate XML',
        sendInvoicesButton: 'Send invoice emails',
        sendInvoicesToAccButton: 'Send mails to clerk',
        deleteContractorErrorTitle: 'Really want to delete users?',
        deleteContractorErrorText: 'Once deleted, you will not be able to recover this users!',
        deleteContractorErrorCancelButton: 'Cancel',
        deleteContractorErrorOKButton: 'I understand',
        deleteContractorSuccessText: 'Users have been deleted successfully!',
        deleteContractorInfoTitle: 'Everything remained as before',
        deleteContractorInfoText: 'Users are safe!',
        generatePDFSuccessText: 'PDFs has been generated successfully!',
        generateXMLSuccessText: 'XML has been generated successfully!',
        mailSuccessText: 'The emails has been sent successfully!',
        successTitle: 'Success!',
        okButton: 'OK'
    }
};
